import React from 'react';

export default function Toggle({ label, checked, onChange, hint }) {
  const switchBase = 'relative inline-block w-[38px] h-[22px] shrink-0 border rounded-xl cursor-pointer transition-all duration-200';
  const switchState = checked
    ? 'bg-accent-blue border-accent-blue'
    : 'bg-surface-raised border-border';
  const thumbBase = 'absolute top-[2px] left-[2px] w-4 h-4 rounded-full transition-all duration-200';
  const thumbState = checked ? 'bg-white translate-x-4' : 'bg-text-muted';
  return (
    <label className="flex justify-between items-center gap-3 py-[0.45rem] cursor-pointer">
      <span className="text-[0.85rem] text-text flex flex-col gap-[0.15rem]">
        {label}
        {hint && <span className="text-[0.73rem] text-text-dim font-normal">{hint}</span>}
      </span>
      <span className={`${switchBase} ${switchState}`}>
        <input
          type="checkbox"
          className="absolute opacity-0 w-full h-full cursor-pointer m-0"
          checked={!!checked}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        <span className={`${thumbBase} ${thumbState}`} />
      </span>
    </label>
  );
}
